import { useSelector } from "react-redux";
import { Header, InfoIcon, LineDivider, PriceItem, StickyContainer, Title, Wrapper } from "./style";
import { normalizePrice } from "../../../utils";
import { CashbackBadge } from "../../ui";
import i18next from "i18next";

const PriceComponent = () => {
  const { t } = i18next;
  const { currency } = useSelector(state => state.appConfigs);
  const { totalPrice, partnerFees, clientFees, cashback, cashbackCurrency } = useSelector(state => state.prebook);

  const baseFare = totalPrice[currency] - (partnerFees?.[currency] || 0) - (clientFees?.[currency] || 0);
  const taxes = (partnerFees?.[currency] || 0) + (clientFees?.[currency] || 0);

  return (
    <StickyContainer>
      <Wrapper>
        <Header>
          <Title>{t("to_pay_title")}</Title>
        </Header>

        <PriceItem $isSmallText>
          <span>{t("base_fare")}:</span>
          <span>
            {normalizePrice(baseFare.toFixed(2))} {currency}
          </span>
        </PriceItem>

        {taxes > 0 && (
          <PriceItem $isSmallText>
            <span>
              {t("taxes_and_fees")} <InfoIcon title={t("includes_service_charges")}>ⓘ</InfoIcon>
            </span>
            <span>
              {normalizePrice(taxes.toFixed(2))} {currency}
            </span>
          </PriceItem>
        )}

        <LineDivider />

        <PriceItem>
          <span className="price__footer">{t("total")}:</span>
          <span className="total__amount">
            {normalizePrice(totalPrice[currency].toFixed(2))} {currency}
          </span>
        </PriceItem>

        {/* кэшбек b2c — бейдж под итогом (0 / выключен — не рисуется) */}
        <CashbackBadge amount={cashback} currency={cashbackCurrency || currency} />
      </Wrapper>
    </StickyContainer>
  );
};

export default PriceComponent;
